module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_List_Maps"
    }
  }, [_vm._v("List of Archival Maps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_List_Tables"
    }
  }, [_vm._v("List of Tables")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Corrections"
    }
  }, [_vm._v("Corrections to Volume Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_vm._v("Appendices with Organizational Tables and Documents Regarding Specific Stages of the Battle For Smolensk")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("A")]), _vm._v(" The Composition, Dispositions, Command Cadre, and Armored Strength of Mechanized Corps Supporting the Western Front in July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("B")]), _vm._v(" The Western Front’s Lepel’ Counterstroke, 6-9 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter_3"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("C")]), _vm._v(" Army Group Center’s Advance on Smolensk and the Timoshenko “Counteroffensive,” 10-15 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter_4"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("D")]), _vm._v(" The Composition and Command Cadre of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v(" of Reserve Armies, 14 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter_5"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("E")]), _vm._v(" The Composition and Command Cadre of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v(" of the Mozhaisk Defense Line, 18 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter_6"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("F")]), _vm._v(" Army Group Center’s Encirclement Battle at Smolensk, 16-23 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("G")]), _vm._v(" The First Soviet Counteroffensive, 23-31 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("H")]), _vm._v(" The Struggle for the Smolensk Pocket, 23-31 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("I")]), _vm._v(" The Northern Flank: Nevel’ and Velikie Luki, 16-31 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("J")]), _vm._v(" The Southern Flank, the Fall of Mogilev and the Problem of 21st Army (Guderian’s Advance to the Sozh River), 16-31 July 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("K")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armeegruppe")]), _vm._v(" Guderian’s Destruction of Group Kachalov, 31 July-6 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("L")]), _vm._v(" The Reduction of the Smolensk Pocket, 1-6 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("M")]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stavka")]), _vm._v(" Regroups its Forces, 30 July-11 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("N")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armeegruppe")]), _vm._v(" Guderian’s and Second Army’s Southward March and the Fall of Gomel’, 8-21 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("O")]), _vm._v(" The Second Soviet Counteroffensive: The Western Front’s Dukhovshchina Offensive, 6-24 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("P")]), _vm._v(" The Second Soviet Counteroffensive: The Reserve Front’s El’nia Offensive, 8-24 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Q")]), _vm._v(" The Northern Flank: Group Stumme’s Advance to Velikie Luki and Toropets, 21-28 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("R")]), _vm._v(" The Northern Flank: Group Stumme’s Advance to Zapadnaia Dvina, 29 August-9 September")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("S")]), _vm._v(" The Third Soviet Counteroffensive: The Western Front’s Dukhovshchina Offensive, 25 August-10 September 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("T")]), _vm._v(" The Third Soviet Counteroffensive: The Reserve Front’s El’nia Offensive, 30 August-10 September 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("U")]), _vm._v(" (Part 1) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armeegruppe")]), _vm._v(" Guderian’s Jockeying for Position along the Desna River, 22-25 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("U")]), _vm._v(" (Part 2) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armeegruppe")]), _vm._v(" Guderian’s Advance across the Desna River, 25-28 August 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("U")]), _vm._v(" (Part 3) The Third Soviet Counteroffensive: The Briansk Front’s Roslavl’-Novozybkov Offensive, 29 August-14 September 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("V")]), _vm._v(" The Roslavl’-Novozybkov Offensive: The Records of 108th Tank Division and 40th Army’s 10th Tank Division, 28 August-14 September 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("W")]), _vm._v(" Excerpts from the Southwestern Front’s Daily Operational Directives and Summaries about 40th Army’s Positions and Situation, 28 August-10 September 1941 [not in the narrative]")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index to Documents and Tables")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0